//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
export default {
  name: 'StockInConfirm',
  components: {
    CyMobileLayout
  },
  data () {
    return {
      jgFlag: true,
      planId: this.$route.query.planId,
      detailId: this.$route.query.detailId,
      planDateId: this.$route.query.planDateId,
      planInfo: {},
      recordList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      let that = this
      let url = '/wms/stockin/detail/getStockInRecord'
      that.$axiosWeb.post(url, null, {params: {planId: that.planId}}).then(function (res) {
        if (res.meta.success) {
          that.planInfo = res.data.planInfo
          that.recordList = res.data.recordList
        } else {
          that.$Msgbox.alert(res.meta.message, '入库记录信息获取失败！')
        }
      })
    },

    stockInFinish: function () {
      let that = this
      let url = '/wms/stockin/confirm/stockInFinish'
      that.$axiosWeb.post(url, null, {params: {planId: that.planId, planDateId: that.planDateId}}).then(function (res) {
        if (res.meta.success) {
          that.$Msgbox.alert('入库完成')
          location.href = '/wx/wms/StockInConfirmPlanList'
        } else {
          that.$Msgbox.alert(res.meta.message, '入库失败')
        }
      })
    },
    goBack: function () {
      let that = this
      location.href = '/wx/wms/stockInConfirm?planId=' + that.planId + '&planDateId=' + that.planDateId
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockin/StockInRecordDetail.vue